(async function () {
  const Layer = await waitForLayer();
  const { defineApp, register } = Layer.api.components;


  register(
    "u-dynamic-shipping-app",
    defineApp({
      name: "UDynamicShippingApp",
      props: {
        threshold: {
          type: "number",
          default: 100,
          reflect: true,
        },
      },
      setup(props, { vue_lib }) {
        const { ref, computed } = vue_lib;


        const cart_value = ref(0);

        Layer.api.cart.onCartSync((data) => {
          cart_value.value = (data.total_price || 0) / 100.0;
        });

        const unlocked = computed(() => {
          return cart_value.value >= props.threshold;
        })

        const value = computed(() => {
          const threshold = props.threshold;
          const current = cart_value.value;
          if (current >= threshold) return 0;
          return ( threshold - current).toFixed(2);
        })

        console.log(value)
        return {
          get value() {
            return value.value;
          },
          get unlocked() {
            return unlocked.value;
          }
        };
      },

    })
  );
})();
